import { ActionType, AlertActionButtonIconClass } from "./alerts-enums";
import { Guid } from "../../shared/utils/guid.helper";

export class ActionModel {
  id: string;
  title: string;
  actionType: ActionType;
  actionData: string;
  iconClass?: string;

  constructor(data?: Partial<ActionModel>) {
    this.id = data?.id ?? Guid.EmptyGuid;
    this.title = data?.title ?? "";
    this.actionType = data?.actionType ?? ActionType.Manual;
    this.actionData = data?.actionData ?? "";
    this.iconClass = AlertActionButtonIconClass[this.actionType] || 'd-none';
  }
}
